import type { ArtAsset } from "@sins2-atlas/game-data";
import { artSrc } from "../lib/art";

/** A dataset art asset as an <img>: srcSet from the DPI flags (never referencing a variant
 * the game doesn't ship) and real width/height so layout never shifts — assets are not
 * uniform (the envoy hud icon is 47×33 against the usual 85×40). */
export function ArtImage({
  asset,
  alt,
  className,
}: {
  asset: ArtAsset;
  /** Empty for decorative uses next to the unit's visible name. */
  alt: string;
  className?: string;
}) {
  const { src, srcSet } = artSrc(asset);
  return (
    <img
      src={src}
      srcSet={srcSet}
      width={asset.width}
      height={asset.height}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={className}
    />
  );
}
